<template>
  <div class="page-agreement">
    <data-privacy v-if="type === 'privacy'"></data-privacy>
    <data-conditions v-else></data-conditions>
  </div>
</template>

<script>

export default {
  data () {
    return {
      type: ''
    }
  },
  created () {
    this.type = this.$route.query.type
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .page-agreement {
    padding: 15px;
    width: 100%;
  }
</style>
